<template>
    <v-container fluid>
        <v-row>
            <v-col 
                style="display: flex; align-content: center; align-items: center;"
                cols="6"
                lg="10"
                md="8"
                sm="6"
            >
                <h3>Payments Configuration</h3>
            </v-col>
            <v-col 
                style="text-align: right;"
                cols="6"
                lg="2"
                md="4"
                sm="6"
            >
                <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn 
                            v-bind="attrs"
                            v-on="on"
                            :to="{ name: 'paymentsConfigurationForm', params: {id: 0} }"
                        >
                            New Payment Configuration
                        </v-btn>
                    </template>
                    <span>New Payment Configuration</span>
                </v-tooltip>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-form @submit.prevent="getRegisters">
                    <v-text-field
                        v-model="filter.fastSearch"
                        label="Quick Search"
                        prepend-inner-icon="mdi mdi-magnify"
                        single-line
                        outlined
                        @click:prepend-inner="getRegisters"
                        dense
                    ></v-text-field>
                </v-form>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-data-table
                    :headers="headers"
                    :items="filteredSearch"
                    :options.sync="options"
                    :loading="loading"
                    :items-per-page="10"
                    no-data-text="No Record Found"
                >
                    <template v-slot:item.action="{item}">
                        <ActionList 
                            :id="item.id" 
                            :link="'paymentsConfigurationForm'"
                            :showButtons="{
                                edit: true,
                                delete: true,
                            }"
                            @confirmDelete="confirmDelete"  />
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <ActionDialog 
            v-on:methodConfirmToCall="dialog.methodConfirm"
            :showDialog.sync="dialog.show"
            :headerTitle="dialog.headerText"
            :bodyText="dialog.bodyText"
            :params="dialog.params"
        />

    </v-container>
</template>

<script>
    import Helpers from '@/utilities/Helpers';
    import ActionList from "@/components/Layout/ActionList";
    import ActionDialog from "@/components/Layout/ActionDialog";

    export default ({

        components: {
            ActionList: ActionList,
            ActionDialog: ActionDialog
        },

        mixins: [Helpers],

        data: () => ({

            loading: false,

            filter: {
                fastSearch: ''
            },

            dialog: {
                show: false,
                headerText: "",
                bodyText: "",
                methodConfirm: ( () => {} ),
                params: null
            },

            headers: [
                { text: "ID", value: "id", sortable: true, size: "5%" },
                { text: "Job ID", value: "idService", sortable: true },
                { text: "Customer", value: "customerName", sortable: true },
                { text: "Address", value: "customerAddress", sortable: true },
                { text: "Description", value: "description", sortable: true },
                { text: "Installment", value: "parcelNumber", sortable: true },
                { text: "Percentage", value: "percentageFormatted", sortable: true },
                { text: "Actions", value: "action", sortable: false, align: "center" }
            ],

            options: { rowsPerPage: 10, page: 1 },

            listPaymentsConfiguration: []
        }),

        computed: {

            filteredSearch: function() {
                return this.listPaymentsConfiguration.filter((paymentsConfigurationFilter) => {
                    
                    const filter = this.filter.fastSearch.toLowerCase();

                    var customerName = paymentsConfigurationFilter.customerName.toLowerCase().match(filter)
                    var customerAddress = paymentsConfigurationFilter.customerAddress.toLowerCase().match(filter)
                    var description = paymentsConfigurationFilter.description.toLowerCase().match(filter)
                    var idService = paymentsConfigurationFilter.idService.toString().match(filter);
                    var id = paymentsConfigurationFilter.id.toString().match(filter);

                    if(customerName != null) { return customerName; } 
                    else if(customerAddress != null) { return customerAddress; } 
                    else if(description != null) { return description; } 
                    else if(idService != null) { return idService; } 
                    else { return id; }
                });
            }
        },

        methods: {
            
            async getRegisters() {

                this.listPaymentsConfiguration = await this.$store.dispatch("servicePaymentsConfigurationModule/List");
            },

            confirmDelete(id) {

                this.dialog = {
                    show: true,
                    headerText: 'Confirmation',
                    bodyText: 'You will DELETE this Payment Configuration, confirm your decision?',
                    methodConfirm: this.delete,
                    params: id
                };
            },

            async delete(id) {

                this.showLoading();

                let result = await this.$store.dispatch("servicePaymentsConfigurationModule/Delete", id);

                if (result.success) {
                    this.showToast("success", "Success!", result.message);
                }
                else {
                    this.showToast("error", "Error!", result.message);
                }

                this.getRegisters();

                this.hideLoading();
            },

        },

        async created() {
            this.showLoading();
            await this.getRegisters();
            this.hideLoading();
        }
    })
</script>
